/**
 * DevExtreme (esm/__internal/core/license/license_validation.js)
 * Version: 25.1.4
 * Build date: Tue Aug 05 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export function parseLicenseKey(encodedKey) {}
export function validateLicense(licenseKey, version) {}
export function peekValidationPerformed() {}
export function setLicenseCheckSkipCondition() {}
export default {
    validateLicense: validateLicense
};
